import React from "react";
import { ChevronLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import iso9001Img from "../../asset/certificates/ISO 9001.png";
import gstImg from "../../asset/certificates/gstcertificate.png";
import iso14001Img from "../../asset/certificates/ISO 14001.png";
import iafFirstImg from "../../asset/certificates/IAF Registration Certificate/first.jpg";
import iafSecondImg from "../../asset/certificates/IAF Registration Certificate/second.jpg";
import halFirstImg from "../../asset/certificates/HAL Registration Certificate/first.jpg";
import halSecondImg from "../../asset/certificates/HAL Registration Certificate/second.jpg";
import halOutsourcingFirstImg from "../../asset/certificates/haloutsourcing/first.jpg";
import halOutsourcingSecondImg from "../../asset/certificates/haloutsourcing/second.jpg";
import iso9001NabcbImg from "../../asset/certificates/ISO 9001-2015.jpg";
import incorporationFirstImg from "../../asset/certificates/Certificate of Incorporation/first.jpg";
import incorporationSecondImg from "../../asset/certificates/Certificate of Incorporation/second.jpg";
import achillesImg from "../../asset/certificates/ACHILLES CERTIFICATE.jpg";
import "./Certification.css";

const certificates = [
  {
    title: "ISO 9001",
    description: "This certification recognizes our commitment to maintaining a high standard of quality management systems, ensuring that we consistently meet customer expectations.",
    images: [iso9001Img],
  },
  {
    title: "GST Certification",
    description: "Our GST certification ensures compliance with all tax regulations, demonstrating our commitment to legal and transparent business operations.",
    images: [gstImg],
  },
  {
    title: "ISO 14001",
    description: "As part of our dedication to environmental responsibility, this certification highlights our effective management of environmental impact and sustainable practices.",
    images: [iso14001Img],
  },
  {
    title: "IAF Registration Certificate",
    description: "This certificate serves as official recognition of our accredited status. It confirms that our processes meet the required standards set by the accreditation body and reflects our ongoing commitment to quality, reliability, and trust.",
    images: [iafFirstImg, iafSecondImg],
  },
  {
    title: "HAL Registration Certificate",
    description: "This certificate officially recognizes our registration with Hindustan Aeronautics Limited. It confirms our eligibility to participate in projects and collaborations with HAL and highlights our readiness to meet industry requirements.",
    images: [halFirstImg, halSecondImg],
  },
  {
    title: "HAL Registration Certificate (Outsourcing)",
    description: "This HAL Vendor Registration Certificate confirms our official registration with Hindustan Aeronautics Limited's Aircraft Manufacturing Division, Nasik. It authorizes us to undertake machining of aero components and reflects our capability to meet HAL's stringent quality and operational standards.",
    images: [halOutsourcingFirstImg, halOutsourcingSecondImg],
  },
  {
    title: "ISO 9001:2015 (NABCB)",
    description: "NABCB-accredited certification recognizing our robust quality management system, consistent delivery, and commitment to continual improvement and customer satisfaction.",
    images: [iso9001NabcbImg],
  },
  {
    title: "Certificate of Incorporation",
    description: "This certificate confirms the legal incorporation of HARDCOATS INDIA PVT. LTD. and establishes our official company status.",
    images: [incorporationFirstImg, incorporationSecondImg],
  },
  {
    title: "Achilles Certificate",
    description: "This certificate acknowledges our registration and compliance status within the Achilles supplier evaluation framework.",
    images: [achillesImg],
  },
]; 

const Certification = () => {
  const [selectedCertificate, setSelectedCertificate] = React.useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);

  const openCertificate = (certificate) => {
    setSelectedCertificate(certificate);
    setSelectedImageIndex(0);
  };

  const changeImage = (direction) => {
    setSelectedImageIndex((currentIndex) => {
      const imageCount = selectedCertificate.images.length;
      return (currentIndex + direction + imageCount) % imageCount;
    });
  };

  React.useEffect(() => {
    if (!selectedCertificate) return undefined;
    const closeOnEscape = (event) => event.key === "Escape" && setSelectedCertificate(null);
    document.addEventListener("keydown", closeOnEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.style.overflow = "";
    };
  }, [selectedCertificate]);

  return (
    <section className="certificates-section" aria-labelledby="certificates-title">
      <div className="certificates-section__heading">
        <p>Our credentials</p>
        <h2 id="certificates-title">Certificates</h2>
        <span>Standards and systems that support the way we work.</span>
      </div>

      <div className="certificates-grid">
        {certificates.map((certificate) => (
          <article className="certificate-card" key={certificate.title}>
            <p className="certificate-card__type">Hardcoats India Pvt. Ltd.</p>
            <h3>{certificate.title}</h3>
            <p className="certificate-card__description">{certificate.description}</p>
            <button type="button" onClick={() => openCertificate(certificate)}>
              View certificate
            </button>
          </article>
        ))}
      </div>

      {selectedCertificate && (
        <div className="certificate-modal" role="dialog" aria-modal="true" aria-label={selectedCertificate.title} onClick={() => setSelectedCertificate(null)}>
          <div className="certificate-modal__content" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="certificate-modal__close" onClick={() => setSelectedCertificate(null)} aria-label="Close preview">
              <XMarkIcon />
            </button>
            <div className="certificate-modal__preview">
              <img src={selectedCertificate.images[selectedImageIndex]} alt={`${selectedCertificate.title} preview ${selectedImageIndex + 1}`} />
              {selectedCertificate.images.length > 1 && (
                <div className="certificate-modal__controls">
                  <button type="button" onClick={() => changeImage(-1)} aria-label="Previous certificate image">
                    <ChevronLeftIcon />
                  </button>
                  <span>{selectedImageIndex + 1} / {selectedCertificate.images.length}</span>
                  <button type="button" onClick={() => changeImage(1)} aria-label="Next certificate image">
                    <ChevronRightIcon />
                  </button>
                </div>
              )}
            </div>
            <div>
              <p>Certificate preview</p>
              <h3>{selectedCertificate.title}</h3>
              <span>{selectedCertificate.description}</span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certification;
